(function () {
  var storageKey = "announcementBarClosed";

  function wasClosed() {
    try {
      return window.sessionStorage.getItem(storageKey) === "true";
    } catch (error) {
      return false;
    }
  }

  function rememberClosed() {
    try {
      window.sessionStorage.setItem(storageKey, "true");
    } catch (error) {
      return;
    }
  }

  function setPageState(bar, isVisible) {
    bar.classList.toggle("is-visible", isVisible);
    document.body.classList.toggle("announcement-bar-visible", isVisible);
  }

  function initSlider(bar) {
    var sliderElement = bar.querySelector("[data-announcement-slider]");
    var slides = sliderElement ? sliderElement.querySelectorAll(".swiper-slide") : [];

    if (!sliderElement || slides.length < 2 || typeof window.Swiper === "undefined") {
      return;
    }

    bar.announcementSwiper = new window.Swiper(sliderElement, {
      direction: "vertical",
      loop: true,
      speed: 650,
      allowTouchMove: false,
      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      effect: "creative",
      creativeEffect: {
        limitProgress: 2,
        prev: {
          translate: [0, "-100%", 0],
          opacity: 0
        },
        next: {
          translate: [0, "100%", 0],
          opacity: 0
        }
      }
    });
  }

  function initMarquee(bar) {
    var marquee = bar.querySelector(".announcement-bar__marquee");
    var group = bar.querySelector(".announcement-bar__marquee-group");

    if (!marquee || !group) {
      return;
    }

    function updateDuration() {
      var pixelsPerSecond = 55;
      var duration = Math.max(group.scrollWidth / pixelsPerSecond, 14);
      marquee.style.setProperty("--announcement-marquee-duration", duration + "s");
    }

    updateDuration();

    if (typeof window.ResizeObserver !== "undefined") {
      bar.announcementResizeObserver = new window.ResizeObserver(updateDuration);
      bar.announcementResizeObserver.observe(group);
    }
  }

  function initBar(bar) {
    if (!bar || bar.dataset.initialized === "true") {
      return;
    }

    bar.dataset.initialized = "true";
    initSlider(bar);
    initMarquee(bar);

    var closeButton = bar.querySelector("[data-announcement-close]");
    var isThemeEditor = window.Shopify && window.Shopify.designMode;

    if (closeButton) {
      closeButton.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();

        if (bar.announcementRevealTimer) {
          window.clearTimeout(bar.announcementRevealTimer);
        }

        setPageState(bar, false);
        rememberClosed();
      });
    }

    if (wasClosed() && !isThemeEditor) {
      return;
    }

    bar.announcementRevealTimer = window.setTimeout(function () {
      setPageState(bar, true);
    }, isThemeEditor ? 0 : 2000);
  }

  function initAllBars() {
    document.querySelectorAll("[data-announcement-bar]").forEach(initBar);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllBars);
  } else {
    initAllBars();
  }

  document.addEventListener("shopify:section:load", function (event) {
    initBar(event.target.querySelector("[data-announcement-bar]"));
  });

  document.addEventListener("shopify:section:unload", function (event) {
    var bar = event.target.querySelector("[data-announcement-bar]");

    if (bar && bar.announcementSwiper) {
      bar.announcementSwiper.destroy(true, true);
    }

    if (bar && bar.announcementResizeObserver) {
      bar.announcementResizeObserver.disconnect();
    }

    if (bar && bar.announcementRevealTimer) {
      window.clearTimeout(bar.announcementRevealTimer);
    }

    document.body.classList.remove("announcement-bar-visible");
  });
})();
